import { render, staticRenderFns } from "./VeJwCjBkPutin.vue?vue&type=template&id=12948ccc&scoped=true"
import script from "./VeJwCjBkPutin.vue?vue&type=script&lang=js"
export * from "./VeJwCjBkPutin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12948ccc",
  null
  
)

export default component.exports